<template>
<div class="overflow-h bg-white interestMod" v-show="showInterestMod">
	<div v-if="title">
		<!-- <p class="borderb marginh50 pTop" ></p> -->
        <div class="flex-container padding20" v-if="outProduct">
              <div class="fs-14">商品暂时缺货，帮你找到相似商品</div>
              <i class="icon-unfold fs-16 text-bolder"></i>
        </div>
        <div class="text-darker bg-white fs-17 padding20 text-bolder" v-text="title" v-else></div>
	</div>
	<!-- <img :src='imageTitle' width="100%" v-if="imageTitle"/> -->
<!-- 	<cmui-slider :items="items" :loop="item.length>9" :events="true">
		<cmui-slider-item v-for="(i,l) in items.length/9"> -->
    <div v-if="outProduct">
        <div class="scroll-container padding10">
          <div v-for="(i,item) in items" class="padding10">
            <div class="bg-white" style="overflow:hidden;border-radius:8px;">
                <a :href="item.clickUrl"
                   data-scp="ylike.{{i}}"
                   :data-trace-id="item.traceId ? item.traceId : ''"
                   :data-store-id="item.storeId"
                   :data-bk="`item-${item.id}`">
                    <div class="bg-white" style="width: 140px;">
                        <div class="ratio-container pos-r">
                            <div class="img-container">
                                <h6 class="dum_img-new">
                                    <img :src="item.imageUrl" onerror="this.style.display='none'" alt="">
                                </h6>
                            </div>
                            <!-- 添加左上角图片 -->
                            <img :src="item.actTagUrl" alt="" class="pos-a" style="width:35px;height:35px;"
                                 v-show="item.actTagUrl">
                        </div>
                        <div class="padding10">
                            <p class="text-limit1 fs-13">
                                <!-- <span v-if="item.global" class="badge red radius small fs-10" style="padding:0px 2px">自营</span>-->
                                <span class="fs-13 text-darker text-bolder" v-text="item.title"></span>
                            </p>
                            <!-- <p class="fs-13 text-red" v-text="'¥'+item.price"></p> -->
                            <div class="flex-container left">
                                <div class="text-right fs-12 text-red marginr10">
                                    <span>¥</span><span class="fs-18" v-text="item.price"></span>
                                </div>
                                <del class="fs-12 text-lighter text-limit1"
                                     v-show="item.originalPrice !== item.price"
                                     v-text="'¥'+item.originalPrice"></del>
                            </div>
                            <div class="flex-container left marginl10" v-if="item.vipPrice">
                              <span class="text-black fs-14"><span class="fs-12">¥</span>{{item.vipPrice}}</span>
                              <img src="//image1.51tiangou.com/tgou2/img2/product/ico-up_05.png" width="48" alt="">
                            </div>
                        </div>
                    </div>
                </a>
            </div>
          </div>
        </div>
    </div>
    <div v-else>
        <cmui-list :col="3" :space="10" class="paddingh20 paddingb10" v-if="flatten">
            <cmui-list-item v-for="(i,item) in items">
                <div class="border marginb10 border-radius" style="overflow:hidden">
                    <a :href="item.clickUrl" data-scp="ylike.{{i}}"
                       :data-store-id="item.storeId"
                       :data-trace-id="item.traceId ? item.traceId : ''"
                       :data-bk="`item-${item.id}`">
                        <div class="bg-white">
                            <div class="ratio-container pos-r">
                                <div class="img-container">
                                    <h6 class="dum_img-new">
                                        <img :src="item.imageUrl" onerror="this.style.display='none'" alt="">
                                    </h6>
                                </div>
                                <!-- 添加左上角图片 -->
                                <img :src="item.actTagUrl" alt="" class="pos-a" style="width:35px;height:35px;"
                                     v-show="item.actTagUrl">
                            </div>
                            <div class="padding10">
                                <p class="text-fixed2" style="line-height: 1.2;height: 2.4em;">
                                    <!-- <span v-if="item.global" class="badge red radius small fs-10" style="padding:0px 2px">自营</span>-->
                                    <span class="fs-12 text-darker text-bolder" v-text="item.title"></span>
                                </p>
                                <!-- <p class="fs-13 text-red" v-text="'¥'+item.price"></p> -->
                                <div class="flex-container left" v-if="!item.newPrice">
                                    <div class="text-right fs-15 text-red marginr10" v-text="'¥'+item.price"></div>
                                    <del class="fs-11 text-light text-limit1"
                                         v-show="item.originalPrice !== item.price"
                                         v-text="'¥'+item.originalPrice"></del>
                                </div>
                                <div class="flex-container left" v-if="item.vipPrice">
                                    <span class="text-black fs-14"><span class="fs-12">¥</span>{{ item.vipPrice }}</span>
                                    <img src="//image1.51tiangou.com/tgou2/img2/product/ico-up_05.png" width="48" alt="">
                                </div>
                                <!-- 新人价 -->
                                <div class="flex-container left" v-if="item.newPrice">
                                    <span class="text-red fs-12">
                                        <span class="fs-15">¥{{ item.newPrice }}</span> 新人价
                                    </span>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </cmui-list-item>
        </cmui-list>
        <cmui-slider :items="items" :loop="true" :auto="items.length > 6 ? autoPlay : 0" :events="true" v-else>
            <cmui-slider-item v-for="(index,l) in items.length/6">
                <cmui-list :col="3" :space="10" class="paddingh20 paddingb10">
                  <cmui-list-item v-for="(i,item) in items.slice(l*6, (l+1)*6)">
                    <div class="border marginb10 border-radius">
                        <a :href="item.clickUrl" data-scp="ylike.{{i}}"
                           :data-trace-id="item.traceId ? item.traceId : ''"
                           :data-store-id="item.storeId"
                           :data-bk="`item-${item.id}`">
                            <div class="bg-white">
                                <div class="ratio-container pos-r">
                                    <div class="img-container">
                                        <h6 class="dum_img-new">
                                            <img :src="item.imageUrl" onerror="this.style.display='none'" alt="">
                                        </h6>
                                    </div>
                                    <!-- 添加左上角图片 -->
                                    <img :src="item.actTagUrl" alt="" class="pos-a" style="width:35px;height:35px;"
                                         v-show="item.actTagUrl">
                                </div>
                                <div class="padding10">
                                    <p class="text-fixed2" style="line-height: 1.2;height: 2.4em;">
                                        <!-- <span v-if="item.global" class="badge red radius small fs-10" style="padding:0px 2px">自营</span>-->
                                        <span class="fs-12 text-darker" v-text="item.title"></span>
                                    </p>
                                    <!-- <p class="fs-13 text-red" v-text="'¥'+item.price"></p> -->
                                    <div class="flex-container left" v-if="!item.newPrice">
                                        <div class="text-right fs-14 text-red marginr10" v-text="'¥'+item.price"></div>
                                        <del class="fs-11 text-light text-limit1"
                                             v-show="item.originalPrice !== item.price"
                                             v-text="'¥'+item.originalPrice"></del>
                                    </div>
                                    <div class="flex-container left" v-if="item.vipPrice">
                                        <span class="text-black fs-14"><span class="fs-12">¥</span>{{ item.vipPrice }}</span>
                                        <img src="//image1.51tiangou.com/tgou2/img2/product/ico-up_05.png" width="48" alt="">
                                    </div>
                                    <!-- 新人价 -->
                                    <div class="flex-container left" v-if="item.newPrice">
                                        <span class="text-red fs-12">
                                            <span class="fs-15">¥{{ item.newPrice }}</span> 新人价
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                  </cmui-list-item>
                </cmui-list>
            </cmui-slider-item>
        </cmui-slider>
    </div>

</div>
</template>

<script>
import maple from 'maple';

export default {
	el: 'tg-interest'
	, data: {
		showInterestMod: false
		, items: []
		, title: '为您推荐'
		, imageTitle:''
		, flatten: true
        , outProduct: false
	}
	, methods: {
		showInterest: function(items, flatten){
			this.showInterestMod = true;
			this.$set('items', items);
			this.flatten = flatten;
		}
		, setTitle: function(title){
			this.$set('title', title);
		}
		, hideInterest: function(){
			this.showInterestMod = false;
		}
		, useImageTitle:function(src){
			this.$set('title', this.title);
			var src=src||'//img1.tg-img.com/seller/201803/20/D0DE404B-9394-4F32-9FDE-AF0098C2B8E4.png!y';
			this.$set('imageTitle',src)
		}
        , setOutProduct: function(outProduct){
			this.$set('outProduct', outProduct);
		}
	}
	, events:{
		cmuiSlider_onTransitionEnd(target, swiper){
            maple.pageIns.updateTraceProductList();
		}
	}
	, props:{
        items: Object,
        autoPlay: {
            type: Number,
            default: 0
        }
    }
}
</script>
<style lang="scss">
h6.dum_img-new {
	background-image: url(//image1.51tiangou.com/tgou2/img2/dum/dum_dog.png);
	background-size: auto 50%;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	width: 100%;
	height: 100%
}
.swiper-container{
	padding-bottom: 0.66666667rem;
}
.interestMod  .pTop{
	margin-top: .4rem;
}
.interestMod h3{
	width: 8em;
	margin: -.4rem auto .4rem;
	line-height: 1em;
}
</style>